export default {
      id: "checkbox-usage",
      viewBox: "0 0 200 183.09",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#checkbox",
      toString: function () {
        return this.url;
      }
    }